import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=d6d17954&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=ts"
export * from "./Organization.vue?vue&type=script&lang=ts"
import style0 from "./Organization.vue?vue&type=style&index=0&id=d6d17954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d17954",
  null
  
)

export default component.exports